// src/firebase/fcm.js
import {initializeApp} from 'firebase/app';
import {getMessaging, getToken, onMessage} from 'firebase/messaging';
import {REACT_APP_FIREBASE_CONFIG, REACT_APP_FIREBASE_VAPID_KEY} from "../env";

const resolveFirebaseConfig = () => {
  if (typeof REACT_APP_FIREBASE_CONFIG === 'string' && REACT_APP_FIREBASE_CONFIG.trim().startsWith('{')) {
    try {
      return JSON.parse(REACT_APP_FIREBASE_CONFIG);
    } catch (e) {
      console.warn('Invalid REACT_APP_FIREBASE_CONFIG JSON. Falling back to embedded config.');
    }
  }

  return {
    apiKey: REACT_APP_FIREBASE_CONFIG,
    authDomain: "reposweb.firebaseapp.com",
    databaseURL: "https://reposweb.firebaseio.com",
    projectId: "reposweb",
    storageBucket: "reposweb.firebasestorage.app",
    messagingSenderId: "608419033879",
    appId: "1:608419033879:web:ff5b20969228f68d713d52"
  };
};

const firebaseConfig = resolveFirebaseConfig();

// Initialize Firebase
const firebaseApp = initializeApp(firebaseConfig);
const messaging = getMessaging(firebaseApp);

// Request permission and get token
export const requestFCMPermissionAndToken = async () => {
  try {
    if (typeof navigator !== 'undefined' && navigator && navigator.onLine === false) {
      console.warn('Browser is offline. Skipping FCM token request.');
      return null;
    }

    const vapidKey = REACT_APP_FIREBASE_VAPID_KEY;
    // Only request permission if it's in 'default' state
    if (typeof Notification === 'undefined') {
      console.warn('Notifications API is not available in this browser.');
      return null;
    }
    let current = Notification.permission;
    if (current === 'denied') {
      console.warn('Notifications are blocked for this site. Enable them in browser settings and retry.');
      return null;
    }
    if (current === 'default') {
      current = await Notification.requestPermission();
    }
    if (current !== 'granted') {
      console.warn('Notification permission not granted by the user.');
      return null;
    }
    // Wait for service worker ready and pass it to getToken
    const registration = await navigator.serviceWorker.ready;
    const token = await getToken(messaging, {
      vapidKey,
      serviceWorkerRegistration: registration,
    });
    if (!token) {
      console.warn('getToken returned empty token. Check VAPID key, service worker scope, and HTTPS.');
      return null;
    }
    // console.log('FCM Token:', token);
    return token;
  } catch (err) {
    const code = err?.code || err?.name;
    if (code === 'installations/app-offline') {
      console.warn('Firebase Installations unreachable (app-offline). Skipping FCM token request.');
      return null;
    }

    console.error('FCM permission/token error:', err);
    return null;
  }
};

// Listen for foreground messages
export const onFCMMessage = (callback) => {
  onMessage(messaging, callback);
};

export { messaging };
